/**
 * @file index.tsx
 *
 * @fileoverview Renders a CMP service checkbox to automatically consent to a service or message to which service /
 * category user needs to grant consent. For Usercentrics, it renders the Usercentrics checkbox. For CivicCookieControl
 * and CookieScript we render category name and for other CMPs, it renders a simple service name.
 */

import React from 'react';
import { allowedCmpProviders, SERVICES } from '~/jobiqo/lib/cmp';
import styles from './cmpServiceCheckbox.module.scss';
import { camelToTitle } from '~/jobiqo/services/stringHelpers';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface CMPServiceCheckboxProps {
  serviceId: string;
}
const CheckboxCMPElement = ({ serviceId }) => {
  const { APP } = useFrontendConfig();
  const CMP_PROVIDER = APP.CMP_PROVIDER;
  const CMP_TCF = APP.CMP_TCF;
  switch (serviceId) {
    case SERVICES.Youtube:
      switch (CMP_PROVIDER) {
        case allowedCmpProviders.Usercentrics:
          return (
            <div
              className="uc-embed"
              uc-layout="serviceDetails"
              uc-embed-type="service-specific"
              uc-embed-service-id="BJz7qNsdj-7"
            />
          );
        case allowedCmpProviders.CivicCookieControl:
          if (!CMP_TCF) {
            return <div>{camelToTitle(SERVICES.Youtube)} Cookies</div>;
          } else {
            return <div>YouTube Video</div>;
          }
        case allowedCmpProviders.CookieScript:
          return <div>{camelToTitle(SERVICES.Youtube)}</div>;
        default:
          return <div>YouTube Video</div>;
      }

    case SERVICES.Vimeo:
      switch (CMP_PROVIDER) {
        case allowedCmpProviders.Usercentrics:
          return (
            <div
              className="uc-embed"
              uc-layout="serviceDetails"
              uc-embed-type="service-specific"
              uc-embed-service-id="HyEX5Nidi-m"
            />
          );
        case allowedCmpProviders.CivicCookieControl:
          if (!CMP_TCF) {
            return <div>{camelToTitle(SERVICES.Vimeo)} Cookies</div>;
          } else {
            return <div>Vimeo</div>;
          }
        case allowedCmpProviders.CookieScript:
          return <div>{camelToTitle(SERVICES.Vimeo)}</div>;
        default:
          return <div>Vimeo</div>;
      }

    case SERVICES.Mapbox:
      switch (CMP_PROVIDER) {
        case allowedCmpProviders.Usercentrics:
          return (
            <div
              className="uc-embed"
              uc-layout="serviceDetails"
              uc-embed-type="service-specific"
              uc-embed-service-id="U8QkTd2W"
            />
          );
        case allowedCmpProviders.CivicCookieControl:
          if (!CMP_TCF) {
            return <div>{camelToTitle(SERVICES.Mapbox)} Cookies</div>;
          } else {
            return <div>Mapbox</div>;
          }
        case allowedCmpProviders.CookieScript:
          return <div>{camelToTitle(SERVICES.Mapbox)}</div>;
        default:
          return <div>Mapbox</div>;
      }

    default:
      return null;
  }
};

export const CMPServiceCheckbox = ({ serviceId }: CMPServiceCheckboxProps) => {
  return (
    <div className={styles.checkboxDivWrapper}>
      <CheckboxCMPElement serviceId={serviceId} />
    </div>
  );
};
export default CMPServiceCheckbox;
